<script>
    import * as d3 from "d3";
    import { afterUpdate } from "svelte";

    export let scale;
    export let colorscale;
    export let value;
    export let height;
    export let width;
    export let margin;
    export let ticks = 3;
    export let better = "bigger";
    export let header = false;
    export let style = "bar";

    $: h = Math.round((height - 2 * margin) / Object.keys(value).length);
    $: r = Math.max(Math.floor(h / 2.2), 1);
    let axis_g;

    let f = d3.format(".2f")

    afterUpdate(() => {
        let axis = d3.select(axis_g)
        axis.call(d3.axisBottom(scale).ticks(ticks))
        axis.attr("font-family", null).attr("font-size", "9px")

        axis.selectAll("path").attr("stroke", "#555")
        axis.selectAll("line").attr("stroke", "#555")
        axis.selectAll("text").attr("fill", "#555")

        // subgrid

        axis.select("#subticks").selectAll("path")
            .data(scale.ticks(ticks))
            .enter().append("path")
            .merge(axis.select("#subticks").selectAll("path"))
                .attr("d", (d, i) => `M ${scale(d) + .5} 0 V ${-(height - 2 * margin)}`)
                .attr("stroke-width", .5)
                .attr("stroke-dasharray", "1 1")
                .attr("stroke", "#555")
    })

    let labels = false;
</script>

<svg width={width} height={height} on:mouseenter={() => labels = true} on:mouseleave={() => labels = false}>
<g transform="translate({margin}, {margin})">
    {#if style == "bar"}
        {#each value as m, i}
            <rect
                x=0
                y={i * h}
                width={scale(m[1])}
                height={Math.round(h) - 1}
                fill={colorscale(m[0])}
            >
                <title>{m[0]}: {f(m[1])}</title>        
            </rect>
        {/each}
    {:else if style == "dot"}
        {#each value as m, i}
            <path d="M {scale(0)} {Math.floor(i * h) + .5 +  Math.round(h/2)} L {scale(m[1])} {Math.floor(i * h) + .5 +  Math.round(h/2)}"
                fill="none"
                stroke-width=1
                stroke-dasharray="1 1"
                stroke={colorscale(m[0])}
            >      
                <title>{m[0]}: {f(m[1])}</title>         
            </path>
            <circle
                cy={Math.floor(i * h) + .5}
                cx={scale(m[1])}
                r={r}
                fill="none"
                stroke-width=2
                stroke={colorscale(m[0])}
            >      
                <title>{m[0]}: {f(m[1])}</title>            
            </circle>
        {/each}
    {:else if style == "cross"}
        {#each value as m, i}
            <path d="M {scale(0)} {Math.floor(i * h) + .5 +  Math.round(h/2)} L {scale(m[1])} {Math.floor(i * h) + .5 +  Math.round(h/2)}"
                fill="none"
                stroke-width=1
                stroke-dasharray="1 1"
                stroke={colorscale(m[0])}
            >      
                <title>{m[0]}: {f(m[1])}</title>         
            </path>
            <path d="M {scale(m[1]) - r / 2} {Math.floor(i * h) + .5 - r / 2 +  Math.round(h/2)}  l {r} {r} M {scale(m[1]) - r / 2} {Math.floor(i * h) + .5 + r / 2 +  Math.round(h/2)} l {r} {-r} "
                fill="none"
                stroke-width=2
                stroke={colorscale(m[0])}
            >      
                <title>{m[0]}: {f(m[1])}</title>         
            </path>
        {/each}
    {/if}
    {#if labels}
        {#each value as m, i}
            <text
                style="pointer-events: none;"
                font-family="Open Sans, sans-serif"
                font-weight="500"
                font-size="8px"
                fill="#555"
                x={2} 
                y={Math.floor(i * h) - 2 + (style=="bar" ? h - 1 : Math.round(h/2))}>{m[0].toUpperCase()}
            </text>
        {/each}
    {/if}
</g>
<g bind:this={axis_g} transform="translate({margin}, {height - margin})">
    <g id="subticks"></g>
</g>
{#if better}
    <text x={better == "bigger" ? width - margin : margin} y={height - margin} fill="white" text-anchor="middle" dominant-baseline="central">*</text>
{/if}
</svg>



<style>

</style>